webpackJsonp([1],{

/***/ "2YGW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2vJy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3q9x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./src/helpers/Mixins.js
/**
 * Mixins, used application-wide
 * **/
var Mixins = {
  methods: {
    /**
     * Create date WordPress style - /YYYY/MM/DD/
     * @method createPostUrl
     * @param {String} date
     * @return {String}
     * **/
    getWpDate: function getWpDate(date) {
      return date.split(/\s/)[0].replace(/-/g, '/');
    },

    /**
     * Create post params for Vue Router WordPress style - /YYYY/MM/DD/
     * @method createPostUrl
     * @param {String} date
     * @return {Object}
     * **/
    createWpDateSlug: function createWpDateSlug(date) {
      date = this.getWpDate(date).split('/');
      return {
        year: date[0],
        month: date[1],
        day: date[2]
      };
    },

    /**
     * Create post slug WordPress style - /YYYY/MM/DD/
     * @method createPostSlug
     * @param {String} date
     * @param {String} slug
     * @return {String}
     * **/
    createPostSlug: function createPostSlug(date, slug) {
      var id = slug;
      var dateSlug = this.createWpDateSlug(date);
      dateSlug.id = id;
      return dateSlug;
    },

    /**
     * Format a URL WordPress style - /YYYY/MM/DD/post-slug
     * @method createPostUrl
     * @param {String} date
     * @param {String} slug
     * **/
    createPostUrl: function createPostUrl(date, slug) {
      date = date.split(' ')[0].split('-').join('/');
      var url = '/' + date + '/' + slug;
      return url;
    },

    /**
     * Remove the domain part from URL
     * @method removeDomainFromUrl
     * @param {String} url
     * @return {String}
     * **/
    removeDomainFromUrl: function removeDomainFromUrl(url) {
      return url.replace(/^.*\/\/[^/]+/, '').replace('/', '').replace(/\/$/, '');
    },

    /**
     * Set document.title
     * @method setTitle
     * @param {String} newPageTitle [optional]
     * **/
    setTitle: function setTitle(newPageTitle) {
      var store = this.$store;
      var getters = store.getters;
      var title = void 0;
      var delimiter = '-';
      var blogTitle = getters.getLangKey('blogTitle');
      var blogTagline = getters.getLangKey('blogTagline');
      if (!newPageTitle) {
        title = blogTitle + ' ' + delimiter + ' ' + blogTagline;
      } else {
        title = newPageTitle + ' ' + delimiter + ' ' + blogTitle;
      }
      document.title = '' + title;
      this.$root.$emit(store.state.events.pageLoaded);
    },

    /**
     * Create Vue Router route from URL
     * @method createRouteFromUrl
     * @param {String} url
     * @return {Function}
     * **/
    createRouteFromUrl: function createRouteFromUrl(url) {
      url = this.removeDomainFromUrl(url).split('/');
      var slug = url.pop();
      var date = url.splice(0, 3).join('/');
      return this.createPostSlug(date, slug);
    },

    /**
     * Go to a page (/:slug), 'PagePage' route
     * @method goToPage
     * @param {String}
     * @return void
     * **/
    goToPage: function goToPage(slug) {
      return this.$router.push({
        name: 'PagePage',
        params: {
          slug: slug
        }
      });
    },

    /**
     * Remove HTML tags from string
     * @method sanitize
     * @param {String} html
     * @return {String}
     * **/
    sanitize: function sanitize(html) {
      return html.replace(/<\/?[^>]+(>|$)/g, '');
    },

    /**
     * Cap html/text at specified point and add ellipsis symbol
     * @method cap
     * @param {String} html
     * @param {Number} cap [optional]
     * @param {String} ellipsis [optional]
     * @return {String}
     * **/
    cap: function cap(html, _cap, ellipsis) {
      html = this.sanitize(html);
      var visibleCharacters = html.substring(0, _cap || 100);
      var lastWord = visibleCharacters.split(' ').pop();
      visibleCharacters = visibleCharacters.replace(new RegExp(lastWord + '$'), '');
      return visibleCharacters + ' ' + (ellipsis || '...');
    },

    /**
     * Get cookie
     * @method setCookie
     * @param {String} name
     * @private
     * @return {String}
     * **/
    getCookie: function getCookie(name) {
      var dc = document.cookie;
      var prefix = name + '=';
      var begin = dc.indexOf('; ' + prefix);

      if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) {
          return null;
        }
      } else {
        begin += 2;
        var end = document.cookie.indexOf(';', begin);

        if (end === -1) {
          end = dc.length;
        }
      }
      return unescape(dc.substring(begin + prefix.length, end));
    },

    /**
     * Set cookie
     * @method setCookie
     * @param {String} name
     * @param {String} value
     * @param {Number} days
     * @private
     * @return void
     * **/
    setCookie: function setCookie(name, value, days) {
      var d = new Date();
      var expires = void 0;

      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = 'expires=' + d.toUTCString();
      document.cookie = name + '=' + value + ';' + expires;
    },

    /**
     * 404 redirect
     * @method to404
     * @return void
     * **/
    to404: function to404() {
      this.$router.push({
        path: '/404'
      });
      this.$root.$emit(this.$store.state.events.ajax, false);
    },

    /**
     * Apply opacity according to a count
     * @method to404
     * @param {Number} count
     * @return {Number}
     * **/
    setOpacity: function setOpacity(count) {
      if (count <= 5) {
        return 0.2;
      } else if (count <= 7) {
        return 0.4;
      } else if (count <= 10) {
        return 0.5;
      } else if (count <= 15) {
        return 0.6;
      } else if (count <= 20) {
        return 0.7;
      } else if (count <= 25) {
        return 0.8;
      } else if (count <= 30) {
        return 0.9;
      } else {
        return 1;
      }
    }
  }
};

/* harmony default export */ var helpers_Mixins = (Mixins);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoadingOverlay.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LoadingOverlay = ({
  name: 'LoadingOverlay',
  data: function data() {
    return {
      hidden: true,
      hideTimeout: '.25', // optional hide timeout (milliseconds * 1000)
      width: 7, // width of the circular progress bar
      indeterminate: true,
      size: 64 // height and width of the circular bar
    };
  },
  created: function created() {
    var _this = this;

    this.$root.$on(this.$store.state.events.ajax, function (state) {
      if (state) {
        _this.hidden = false;
        return;
      }
      setTimeout(function () {
        _this.hidden = !state;
      }, _this.hideTimeout * 1000);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5f2baf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingOverlay.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay",attrs:{"hidden":_vm.hidden}},[_c('v-progress-circular',{attrs:{"color":this.$store.state.mainColor,"indeterminate":_vm.indeterminate,"width":_vm.width,"size":64}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_LoadingOverlay = (esExports);
// CONCATENATED MODULE: ./src/components/LoadingOverlay.vue
function injectStyle (ssrContext) {
  __webpack_require__("pwwO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  LoadingOverlay,
  components_LoadingOverlay,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_LoadingOverlay = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AnnouncementsBar.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AnnouncementsBar = ({
  name: 'AnnouncementsBar',
  data: function data() {
    return {
      alert: true,
      announcement: this.$store.getters.externalData.announcement
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7f75e84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnouncementsBar.vue
var AnnouncementsBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.announcement.text)?_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-alert',{attrs:{"color":_vm.announcement.type,"icon":_vm.announcement.icon,"value":"true","dismissible":_vm.announcement.dismissible},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.announcement.text)}})])],1)],1)],1):_vm._e()}
var AnnouncementsBar_staticRenderFns = []
var AnnouncementsBar_esExports = { render: AnnouncementsBar_render, staticRenderFns: AnnouncementsBar_staticRenderFns }
/* harmony default export */ var components_AnnouncementsBar = (AnnouncementsBar_esExports);
// CONCATENATED MODULE: ./src/components/AnnouncementsBar.vue
var AnnouncementsBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AnnouncementsBar___vue_template_functional__ = false
/* styles */
var AnnouncementsBar___vue_styles__ = null
/* scopeId */
var AnnouncementsBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AnnouncementsBar___vue_module_identifier__ = null
var AnnouncementsBar_Component = AnnouncementsBar_normalizeComponent(
  AnnouncementsBar,
  components_AnnouncementsBar,
  AnnouncementsBar___vue_template_functional__,
  AnnouncementsBar___vue_styles__,
  AnnouncementsBar___vue_scopeId__,
  AnnouncementsBar___vue_module_identifier__
)

/* harmony default export */ var src_components_AnnouncementsBar = (AnnouncementsBar_Component.exports);

// CONCATENATED MODULE: ./src/helpers/SocialBarData.js
/**
 * Social services for the SocialBar component
 * **/
var SocialBarData = [{
  icon: 'twitter',
  url: function url(_url) {
    return 'https://twitter.com/intent/tweet/?text=&url=' + _url;
  }
}, {
  icon: 'facebook',
  url: function url(_url2) {
    return 'https://facebook.com/sharer/sharer.php?u=' + _url2;
  }
}, {
  icon: 'google-plus',
  url: function url(_url3) {
    return 'https://plus.google.com/share?url=' + _url3;
  }
}, {
  icon: 'pinterest',
  url: function url(_url4) {
    return 'https://pinterest.com/pin/create/button/?url=' + _url4;
  }
}, {
  icon: 'linkedin',
  url: function url(_url5) {
    return 'https://www.linkedin.com/shareArticle?mini=true&url=' + _url5;
  }
}, {
  icon: 'xing',
  url: function url(_url6) {
    return 'https://www.xing.com/app/user?op=share;title=;url=' + _url6;
  }
}, {
  icon: 'reddit',
  url: function url(_url7) {
    return 'https://reddit.com/submit/?url=' + _url7;
  }
}, {
  icon: 'tumblr',
  url: function url(_url8) {
    return 'https://www.tumblr.com/widgets/share/tool?posttype=link&title=&caption=&shareSource=tumblr_share_button&content=' + _url8 + '&canonicalUrl=' + _url8;
  }
}, {
  icon: 'whatsapp',
  url: function url(_url9, siteTitle) {
    return 'whatsapp://send?text=' + encodeURIComponent(siteTitle) + ' ' + _url9;
  }
}, {
  icon: 'rss',
  url: function url() {
    return 'http://api.martinivanov.net/feed/';
  }
}, {
  icon: 'email',
  url: function url(_url10, siteTitle) {
    return 'mailto:?subject=' + siteTitle + '&body=' + _url10;
  }
}];

/* harmony default export */ var helpers_SocialBarData = (SocialBarData);
// EXTERNAL MODULE: ./static/mdi/css/materialdesignicons.min.css
var materialdesignicons_min = __webpack_require__("3q9x");
var materialdesignicons_min_default = /*#__PURE__*/__webpack_require__.n(materialdesignicons_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MdiIcon.vue
//
//
//



/* harmony default export */ var MdiIcon = ({
  name: 'MdiIcon',
  data: function data() {
    return {
      icon: this.$attrs.icon,
      size: this.$attrs.size || 24, // 18, 24, 36, 48
      color: this.$attrs.color || '#757575'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e580824","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MdiIcon.vue
var MdiIcon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("mdi mdi-" + _vm.icon + " mdi-" + _vm.size + "px"),style:({color: _vm.color})})}
var MdiIcon_staticRenderFns = []
var MdiIcon_esExports = { render: MdiIcon_render, staticRenderFns: MdiIcon_staticRenderFns }
/* harmony default export */ var components_MdiIcon = (MdiIcon_esExports);
// CONCATENATED MODULE: ./src/components/MdiIcon.vue
var MdiIcon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var MdiIcon___vue_template_functional__ = false
/* styles */
var MdiIcon___vue_styles__ = null
/* scopeId */
var MdiIcon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MdiIcon___vue_module_identifier__ = null
var MdiIcon_Component = MdiIcon_normalizeComponent(
  MdiIcon,
  components_MdiIcon,
  MdiIcon___vue_template_functional__,
  MdiIcon___vue_styles__,
  MdiIcon___vue_scopeId__,
  MdiIcon___vue_module_identifier__
)

/* harmony default export */ var src_components_MdiIcon = (MdiIcon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SocialBar.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SocialBar = ({
  name: 'SocialBar',
  components: {
    MdiIcon: src_components_MdiIcon
  },
  props: ['baseColor'],
  data: function data() {
    return {
      items: helpers_SocialBarData || [], // items
      size: this.$attrs.size || '36', // button width
      state: this.$store.state,
      color: this.$store.state.baseColor,
      siteTitle: this.$store.getters.getLangKey('blogTitle')
    };
  },

  methods: {
    getUrl: function getUrl(index) {
      window.open(this.items[index].url(window.location.href, this.siteTitle), '_blank');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8e67aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialBar.vue
var SocialBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length)?_c('div',{staticClass:"social-bar elevation-12",class:{'social-bar-left': this.$store.getters.sidebar.position === 'right'}},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('v-btn',{style:({width: _vm.size + 'px'}),attrs:{"color":_vm.color,"block":"","raised":""},on:{"click":function($event){_vm.getUrl(index)}}},[_c('mdi-icon',{attrs:{"icon":item.icon,"size":"24","color":"#fff"}})],1)],1)}))]):_vm._e()}
var SocialBar_staticRenderFns = []
var SocialBar_esExports = { render: SocialBar_render, staticRenderFns: SocialBar_staticRenderFns }
/* harmony default export */ var components_SocialBar = (SocialBar_esExports);
// CONCATENATED MODULE: ./src/components/SocialBar.vue
function SocialBar_injectStyle (ssrContext) {
  __webpack_require__("aj5t")
}
var SocialBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SocialBar___vue_template_functional__ = false
/* styles */
var SocialBar___vue_styles__ = SocialBar_injectStyle
/* scopeId */
var SocialBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SocialBar___vue_module_identifier__ = null
var SocialBar_Component = SocialBar_normalizeComponent(
  SocialBar,
  components_SocialBar,
  SocialBar___vue_template_functional__,
  SocialBar___vue_styles__,
  SocialBar___vue_scopeId__,
  SocialBar___vue_module_identifier__
)

/* harmony default export */ var src_components_SocialBar = (SocialBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CookieConsentBar.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CookieConsentBar = ({
  name: 'CookieConsentBar',
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      message: this.$attrs.message || 'We use cookies to ensure you get the best experience.',
      dismiss: this.$attrs.ok || 'OK',
      view: this.$attrs.view || 'Policy',
      visible: false,
      page: this.$attrs.page || '/cookies',
      cookie: this.$attrs.cookie || '_cookie_policy_',
      days: this.$attrs.days || 7,
      color: this.$store.state.baseColor
    };
  },
  mounted: function mounted() {
    if (!this.getCookie(this.cookie)) {
      this.visible = true;
    }
  },

  methods: {
    /**
     * Navigate to the cookie policy page
     * @method viewPolicy
     * @return void
     */
    viewPolicy: function viewPolicy() {
      this.$router.push({
        name: 'PagePage',
        params: {
          slug: this.page
        }
      });
    },

    /**
     * Close the message
     * @method dismissMessage
     * @return void
     */
    dismissMessage: function dismissMessage() {
      this.visible = false;
      this.setCookie(this.cookie, true, this.days);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b26318","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieConsentBar.vue
var CookieConsentBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"cookie-consent-bar elevation-12"},[_c('v-toolbar',{attrs:{"dense":"","color":_vm.color}},[_c('v-toolbar-title',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"raised":""},domProps:{"innerHTML":_vm._s(_vm.view)},on:{"click":_vm.viewPolicy}}),_vm._v(" "),_c('v-btn',{attrs:{"raised":""},domProps:{"innerHTML":_vm._s(_vm.dismiss)},on:{"click":_vm.dismissMessage}})],1)],1):_vm._e()}
var CookieConsentBar_staticRenderFns = []
var CookieConsentBar_esExports = { render: CookieConsentBar_render, staticRenderFns: CookieConsentBar_staticRenderFns }
/* harmony default export */ var components_CookieConsentBar = (CookieConsentBar_esExports);
// CONCATENATED MODULE: ./src/components/CookieConsentBar.vue
function CookieConsentBar_injectStyle (ssrContext) {
  __webpack_require__("ej7G")
}
var CookieConsentBar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CookieConsentBar___vue_template_functional__ = false
/* styles */
var CookieConsentBar___vue_styles__ = CookieConsentBar_injectStyle
/* scopeId */
var CookieConsentBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CookieConsentBar___vue_module_identifier__ = null
var CookieConsentBar_Component = CookieConsentBar_normalizeComponent(
  CookieConsentBar,
  components_CookieConsentBar,
  CookieConsentBar___vue_template_functional__,
  CookieConsentBar___vue_styles__,
  CookieConsentBar___vue_scopeId__,
  CookieConsentBar___vue_module_identifier__
)

/* harmony default export */ var src_components_CookieConsentBar = (CookieConsentBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchForm.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SearchForm = ({
  name: 'SearchForm',
  data: function data() {
    return {
      query: null,
      baseColor: this.$store.state.baseColor
    };
  },

  methods: {
    /**
     * Redirect to the search results page and pass the query parameter
     * @method search
     * @return void
     * **/
    search: function search() {
      var query = this.query;
      if (!query) {
        return;
      }
      this.$router.push({
        path: '/search/1/' + this.query
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b34719e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchForm.vue
var SearchForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();_vm.search($event)}}},[_c('v-text-field',{attrs:{"color":_vm.baseColor,"label":"search","append-icon":"search"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)}
var SearchForm_staticRenderFns = []
var SearchForm_esExports = { render: SearchForm_render, staticRenderFns: SearchForm_staticRenderFns }
/* harmony default export */ var components_SearchForm = (SearchForm_esExports);
// CONCATENATED MODULE: ./src/components/SearchForm.vue
var SearchForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchForm___vue_template_functional__ = false
/* styles */
var SearchForm___vue_styles__ = null
/* scopeId */
var SearchForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchForm___vue_module_identifier__ = null
var SearchForm_Component = SearchForm_normalizeComponent(
  SearchForm,
  components_SearchForm,
  SearchForm___vue_template_functional__,
  SearchForm___vue_styles__,
  SearchForm___vue_scopeId__,
  SearchForm___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchForm = (SearchForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/InfoBox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InfoBox = ({
  name: 'InfoBox',
  data: function data() {
    return {
      infoBox: this.$store.getters.getInfoBox,
      pageTopSlug: this.$store.state.pageTopSlug
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a2f6e38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoBox.vue
var InfoBox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-3 pb-0"},[_c('h4',{staticClass:"title grey--text text--darken-1 pt-0 pb-3"},[_c('router-link',{staticClass:"grey--text text--darken-1 no-decoration",attrs:{"to":(_vm.pageTopSlug + "/" + (_vm.infoBox.slug))},domProps:{"innerHTML":_vm._s(_vm.infoBox.title_plain)}})],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.infoBox.content)}})])}
var InfoBox_staticRenderFns = []
var InfoBox_esExports = { render: InfoBox_render, staticRenderFns: InfoBox_staticRenderFns }
/* harmony default export */ var components_InfoBox = (InfoBox_esExports);
// CONCATENATED MODULE: ./src/components/InfoBox.vue
var InfoBox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var InfoBox___vue_template_functional__ = false
/* styles */
var InfoBox___vue_styles__ = null
/* scopeId */
var InfoBox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InfoBox___vue_module_identifier__ = null
var InfoBox_Component = InfoBox_normalizeComponent(
  InfoBox,
  components_InfoBox,
  InfoBox___vue_template_functional__,
  InfoBox___vue_styles__,
  InfoBox___vue_scopeId__,
  InfoBox___vue_module_identifier__
)

/* harmony default export */ var src_components_InfoBox = (InfoBox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SidebarLinks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SidebarLinks = ({
  name: 'SidebarLinks',
  data: function data() {
    return {
      items: this.$store.getters.sidebar.items.pages,
      pageTopSlug: this.$store.state.pageTopSlug
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38863480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarLinks.vue
var SidebarLinks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.links.length)?_c('div',[(_vm.items.heading)?_c('v-container',{staticClass:"pt-3 pb-0"},[_c('h4',{staticClass:"title grey--text text--darken-1 pt-0 pb-3",domProps:{"innerHTML":_vm._s(_vm.items.heading)}})]):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.items.links),function(link,index){return _c('v-list-tile',{key:index,attrs:{"ripple":"","router":"","to":(_vm.pageTopSlug + "/" + (link.slug))}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(link.title)}})],1)],1)}))],1):_vm._e()}
var SidebarLinks_staticRenderFns = []
var SidebarLinks_esExports = { render: SidebarLinks_render, staticRenderFns: SidebarLinks_staticRenderFns }
/* harmony default export */ var components_SidebarLinks = (SidebarLinks_esExports);
// CONCATENATED MODULE: ./src/components/SidebarLinks.vue
var SidebarLinks_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SidebarLinks___vue_template_functional__ = false
/* styles */
var SidebarLinks___vue_styles__ = null
/* scopeId */
var SidebarLinks___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarLinks___vue_module_identifier__ = null
var SidebarLinks_Component = SidebarLinks_normalizeComponent(
  SidebarLinks,
  components_SidebarLinks,
  SidebarLinks___vue_template_functional__,
  SidebarLinks___vue_styles__,
  SidebarLinks___vue_scopeId__,
  SidebarLinks___vue_module_identifier__
)

/* harmony default export */ var src_components_SidebarLinks = (SidebarLinks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SidebarBoxes.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SidebarBoxes = ({
  name: 'SidebarBoxes',
  data: function data() {
    return {
      items: this.$store.getters.sidebar.items.customBoxes || []
    };
  },

  methods: {
    getUrl: function getUrl(url, target) {
      if (url) {
        window.open(url, target || '_blank');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-697269e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarBoxes.vue
var SidebarBoxes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('v-container',{staticClass:"pt-3 pb-0"},_vm._l((_vm.items),function(item,index){return (item.render)?_c('v-card',{key:index,staticClass:"elevation-6 mb-3 sidebar-box",class:{'box-clickable': item.linkUrl}},[(item.imageUrl)?_c('v-card-media',{attrs:{"src":item.imageUrl,"height":item.imageHeight || 200},on:{"click":function($event){_vm.getUrl(item.linkUrl)}}}):_vm._e(),_vm._v(" "),(item.heading || item.description)?_c('v-card-title',{on:{"click":function($event){_vm.getUrl(item.linkUrl)}}},[(item.heading)?_c('h5',{staticClass:"subheading grey--text text--darken-1 pt-0 pb-3",domProps:{"innerHTML":_vm._s(item.heading)}}):_vm._e(),_vm._v(" "),(item.description)?_c('div',{domProps:{"innerHTML":_vm._s(item.description)}}):_vm._e()]):_vm._e()],1):_vm._e()})):_vm._e()}
var SidebarBoxes_staticRenderFns = []
var SidebarBoxes_esExports = { render: SidebarBoxes_render, staticRenderFns: SidebarBoxes_staticRenderFns }
/* harmony default export */ var components_SidebarBoxes = (SidebarBoxes_esExports);
// CONCATENATED MODULE: ./src/components/SidebarBoxes.vue
function SidebarBoxes_injectStyle (ssrContext) {
  __webpack_require__("ifOc")
}
var SidebarBoxes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SidebarBoxes___vue_template_functional__ = false
/* styles */
var SidebarBoxes___vue_styles__ = SidebarBoxes_injectStyle
/* scopeId */
var SidebarBoxes___vue_scopeId__ = "data-v-697269e5"
/* moduleIdentifier (server only) */
var SidebarBoxes___vue_module_identifier__ = null
var SidebarBoxes_Component = SidebarBoxes_normalizeComponent(
  SidebarBoxes,
  components_SidebarBoxes,
  SidebarBoxes___vue_template_functional__,
  SidebarBoxes___vue_styles__,
  SidebarBoxes___vue_scopeId__,
  SidebarBoxes___vue_module_identifier__
)

/* harmony default export */ var src_components_SidebarBoxes = (SidebarBoxes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CategoriesCloud.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CategoriesCloud = ({
  name: 'CategoriesCloud',
  data: function data() {
    return {
      categories: this.$store.state.bootstrapData.categories || [],
      minCount: this.$attrs['min-count'] || 0
    };
  },

  computed: {
    filterCategoriesByCount: function filterCategoriesByCount() {
      var _this = this;

      return this.categories.filter(function (category) {
        return category.post_count > _this.minCount;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6715d17d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoriesCloud.vue
var CategoriesCloud_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filterCategoriesByCount.length)?_c('div',[_c('v-container',{staticClass:"pt-3"},[_c('h4',{staticClass:"title grey--text text--darken-1 pt-0 pb-0"},[_c('router-link',{staticClass:"grey--text text--darken-1 no-decoration",attrs:{"to":"/category"},domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('categories'))}})],1)]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.filterCategoriesByCount),function(category,index){return _c('v-list-tile',{key:index,attrs:{"ripple":"","router":"","to":("/category/" + (category.slug))}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(category.title)}})],1),_vm._v(" "),_c('v-list-tile-action',{domProps:{"innerHTML":_vm._s(category.post_count)}})],1)}))],1):_vm._e()}
var CategoriesCloud_staticRenderFns = []
var CategoriesCloud_esExports = { render: CategoriesCloud_render, staticRenderFns: CategoriesCloud_staticRenderFns }
/* harmony default export */ var components_CategoriesCloud = (CategoriesCloud_esExports);
// CONCATENATED MODULE: ./src/components/CategoriesCloud.vue
var CategoriesCloud_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CategoriesCloud___vue_template_functional__ = false
/* styles */
var CategoriesCloud___vue_styles__ = null
/* scopeId */
var CategoriesCloud___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CategoriesCloud___vue_module_identifier__ = null
var CategoriesCloud_Component = CategoriesCloud_normalizeComponent(
  CategoriesCloud,
  components_CategoriesCloud,
  CategoriesCloud___vue_template_functional__,
  CategoriesCloud___vue_styles__,
  CategoriesCloud___vue_scopeId__,
  CategoriesCloud___vue_module_identifier__
)

/* harmony default export */ var src_components_CategoriesCloud = (CategoriesCloud_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TagCloud.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TagCloud = ({
  name: 'TagCloud',
  data: function data() {
    return {
      tags: this.$store.state.bootstrapData.tags || [],
      minCount: this.$attrs['min-count'] || 0
    };
  },

  computed: {
    filterTagsByCount: function filterTagsByCount() {
      var _this = this;

      return this.tags.filter(function (tag) {
        return tag.post_count > _this.minCount;
      });
    }
  },
  methods: {
    /**
     * Calculate the tag size
     * @method tagSize
     * @param {Number} count
     * @return {Number|String}
     * **/
    tagSize: function tagSize(count) {
      return count < 9 ? 'inherit' : count + 'px';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e248a16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagCloud.vue
var TagCloud_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filterTagsByCount.length)?_c('v-container',{staticClass:"tag-cloud pt-3 pb-0"},[_c('h4',{staticClass:"title grey--text text--darken-1 pt-3 pb-3"},[_c('router-link',{staticClass:"grey--text text--darken-1",attrs:{"to":"/tag"},domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('tags'))}})],1),_vm._v(" "),_c('ol',{staticClass:"inside-list bulletless-list"},_vm._l((_vm.filterTagsByCount),function(tag,index){return _c('li',{key:index},[_c('router-link',{style:({'font-size': _vm.tagSize(tag.post_count)}),attrs:{"to":("/tag/" + (tag.slug))}},[_vm._v(_vm._s(tag.title))])],1)}))]):_vm._e()}
var TagCloud_staticRenderFns = []
var TagCloud_esExports = { render: TagCloud_render, staticRenderFns: TagCloud_staticRenderFns }
/* harmony default export */ var components_TagCloud = (TagCloud_esExports);
// CONCATENATED MODULE: ./src/components/TagCloud.vue
function TagCloud_injectStyle (ssrContext) {
  __webpack_require__("2YGW")
}
var TagCloud_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagCloud___vue_template_functional__ = false
/* styles */
var TagCloud___vue_styles__ = TagCloud_injectStyle
/* scopeId */
var TagCloud___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TagCloud___vue_module_identifier__ = null
var TagCloud_Component = TagCloud_normalizeComponent(
  TagCloud,
  components_TagCloud,
  TagCloud___vue_template_functional__,
  TagCloud___vue_styles__,
  TagCloud___vue_scopeId__,
  TagCloud___vue_module_identifier__
)

/* harmony default export */ var src_components_TagCloud = (TagCloud_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LatestPostsSidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LatestPostsSidebar = ({
  name: 'LatestPostsSidebar',
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      posts: this.$store.state.bootstrapData.recentPosts || []
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d131944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LatestPostsSidebar.vue
var LatestPostsSidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.posts && _vm.posts.length)?_c('div',[_c('v-container',{staticClass:"pt-3"},[_c('h4',{staticClass:"title grey--text text--darken-1 pt-0 pb-0",domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('latestPosts'))}})]),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.posts),function(post,index){return _c('v-list-tile',{key:index,attrs:{"ripple":"","router":"","title":post.title,"to":_vm.createPostUrl(post.date, post.slug)}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(post.title)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("chevron_right")])],1)],1)}))],1):_vm._e()}
var LatestPostsSidebar_staticRenderFns = []
var LatestPostsSidebar_esExports = { render: LatestPostsSidebar_render, staticRenderFns: LatestPostsSidebar_staticRenderFns }
/* harmony default export */ var components_LatestPostsSidebar = (LatestPostsSidebar_esExports);
// CONCATENATED MODULE: ./src/components/LatestPostsSidebar.vue
var LatestPostsSidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LatestPostsSidebar___vue_template_functional__ = false
/* styles */
var LatestPostsSidebar___vue_styles__ = null
/* scopeId */
var LatestPostsSidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LatestPostsSidebar___vue_module_identifier__ = null
var LatestPostsSidebar_Component = LatestPostsSidebar_normalizeComponent(
  LatestPostsSidebar,
  components_LatestPostsSidebar,
  LatestPostsSidebar___vue_template_functional__,
  LatestPostsSidebar___vue_styles__,
  LatestPostsSidebar___vue_scopeId__,
  LatestPostsSidebar___vue_module_identifier__
)

/* harmony default export */ var src_components_LatestPostsSidebar = (LatestPostsSidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBarItems.vue
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var NavigationBarItems = ({
  name: 'NavigationBarItems',
  components: {
    SearchForm: src_components_SearchForm,
    InfoBox: src_components_InfoBox,
    SidebarLinks: src_components_SidebarLinks,
    SidebarBoxes: src_components_SidebarBoxes,
    CategoriesCloud: src_components_CategoriesCloud,
    TagCloud: src_components_TagCloud,
    LatestPostsSidebar: src_components_LatestPostsSidebar
  },
  data: function data() {
    return {
      infoBoxData: this.$store.getters.getInfoBox,
      sidebar: this.$store.getters.sidebar,
      categoriesCloudMinCount: this.$store.state.categoriesCloudMinCount,
      tagCloudMinCount: this.$store.state.tagCloudMinCount
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2ed14fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBarItems.vue
var NavigationBarItems_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sidebar.items.searchBar)?_c('v-container',{staticClass:"pt-0 pb-0"},[_c('search-form',{staticClass:"pt-0 pb-0"})],1):_vm._e(),_vm._v(" "),(_vm.sidebar.items.infoBox)?_c('info-box'):_vm._e(),_vm._v(" "),(_vm.sidebar.items.latestPosts)?_c('latest-posts-sidebar'):_vm._e(),_vm._v(" "),_c('sidebar-boxes'),_vm._v(" "),(_vm.sidebar.items.categoriesCloud)?_c('categories-cloud',{attrs:{"min-count":_vm.categoriesCloudMinCount}}):_vm._e(),_vm._v(" "),(_vm.sidebar.items.tagCloud)?_c('tag-cloud',{attrs:{"min-count":_vm.tagCloudMinCount}}):_vm._e(),_vm._v(" "),_c('sidebar-links')],1)}
var NavigationBarItems_staticRenderFns = []
var NavigationBarItems_esExports = { render: NavigationBarItems_render, staticRenderFns: NavigationBarItems_staticRenderFns }
/* harmony default export */ var components_NavigationBarItems = (NavigationBarItems_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBarItems.vue
var NavigationBarItems_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NavigationBarItems___vue_template_functional__ = false
/* styles */
var NavigationBarItems___vue_styles__ = null
/* scopeId */
var NavigationBarItems___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBarItems___vue_module_identifier__ = null
var NavigationBarItems_Component = NavigationBarItems_normalizeComponent(
  NavigationBarItems,
  components_NavigationBarItems,
  NavigationBarItems___vue_template_functional__,
  NavigationBarItems___vue_styles__,
  NavigationBarItems___vue_scopeId__,
  NavigationBarItems___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBarItems = (NavigationBarItems_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AdBlockPlusEnabled.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AdBlockPlusEnabled = ({
  name: 'AdBlockPlusEnabled',
  methods: {
    reload: function reload() {
      window.location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc5bcee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdBlockPlusEnabled.vue
var AdBlockPlusEnabled_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.adBlockPlusEnabled)?_c('div',{class:['ad-block-plus-enabled']},[_c('div',{class:['elevation-12', 'pa-4']},[_c('h4',{class:['subheading', 'grey--text', 'text--darken-1', 'mb-2']},[_vm._v("Please, disable your ad blocker")]),_vm._v("\n    This website is made possible by displaying online advertisements to the visitors.\n    To view the content, please, disable your ad blocker,\n    then "),_c('a',{attrs:{"href":"/"},on:{"click":function($event){$event.preventDefault();_vm.reload()}}},[_vm._v("refresh")]),_vm._v(" the page.")])]):_vm._e()}
var AdBlockPlusEnabled_staticRenderFns = []
var AdBlockPlusEnabled_esExports = { render: AdBlockPlusEnabled_render, staticRenderFns: AdBlockPlusEnabled_staticRenderFns }
/* harmony default export */ var components_AdBlockPlusEnabled = (AdBlockPlusEnabled_esExports);
// CONCATENATED MODULE: ./src/components/AdBlockPlusEnabled.vue
function AdBlockPlusEnabled_injectStyle (ssrContext) {
  __webpack_require__("WtHi")
}
var AdBlockPlusEnabled_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AdBlockPlusEnabled___vue_template_functional__ = false
/* styles */
var AdBlockPlusEnabled___vue_styles__ = AdBlockPlusEnabled_injectStyle
/* scopeId */
var AdBlockPlusEnabled___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AdBlockPlusEnabled___vue_module_identifier__ = null
var AdBlockPlusEnabled_Component = AdBlockPlusEnabled_normalizeComponent(
  AdBlockPlusEnabled,
  components_AdBlockPlusEnabled,
  AdBlockPlusEnabled___vue_template_functional__,
  AdBlockPlusEnabled___vue_styles__,
  AdBlockPlusEnabled___vue_scopeId__,
  AdBlockPlusEnabled___vue_module_identifier__
)

/* harmony default export */ var src_components_AdBlockPlusEnabled = (AdBlockPlusEnabled_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var App = ({
  name: 'app',
  mixins: [helpers_Mixins],
  components: {
    LoadingOverlay: src_components_LoadingOverlay,
    AnnouncementsBar: src_components_AnnouncementsBar,
    SocialBar: src_components_SocialBar,
    CookieConsentBar: src_components_CookieConsentBar,
    NavigationBarItems: src_components_NavigationBarItems,
    AdBlockPlusEnabled: src_components_AdBlockPlusEnabled
  },
  data: function data() {
    return {
      drawer: null,
      year: new Date().getFullYear(),
      infoBoxData: this.$store.getters.getInfoBox,
      baseColor: this.$store.state.baseColor,
      sidebar: this.$store.getters.sidebar,
      pageTopSlug: this.$store.state.pageTopSlug,
      right: this.$store.getters.sidebar.position !== 'left',
      contactPage: this.$store.state.contactPage,
      initialized: false
    };
  },
  created: function created() {
    var _this = this;

    var state = this.$store.state;
    this.$root.$on(state.events.pageLoaded, function () {
      if (!_this.initialized) {
        var element = document.querySelector('aside + .toolbar');
        var color = getComputedStyle(element, null).getPropertyValue('background-color');
        var sheet = function () {
          var style = document.createElement('style');
          style.setAttribute('type', 'text/css');
          style.appendChild(document.createTextNode(''));
          document.head.appendChild(style);
          return style.sheet;
        }();
        sheet.insertRule('main .container a:not(.btn):not([target="_blank"]),\n          .navigation-drawer > .list a.list__tile--active.list__tile.list__tile--link.primary--text,\n          a.primary--text.list__tile--active.list__tile.list__tile--link:not(.btn),\n          .footer a {\n            color: ' + color + ' !important;\n            font-weight: 450;\n            opacity: .7;\n          }', 0);
        sheet.insertRule('main .container a:not(.btn):not([target="_blank"]):hover,\n          .navigation-drawer > .list a.list__tile--active.list__tile.list__tile--link.primary--text:hover,\n          a.primary--text.list__tile--active.list__tile.list__tile--link:not(.btn):hover,\n          .footer a:hover {\n            opacity: 1;\n          }', 0);
        _this.initialized = true;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-582b7cb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('ad-block-plus-enabled'),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"elevation-12",attrs:{"fixed":"","right":_vm.right,"clipped":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('navigation-bar-items')],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","clippedLeft":!_vm.right,"clippedRight":_vm.right,"fixed":"","color":_vm.baseColor}},[(!_vm.right)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e(),_vm._v(" "),_c('v-toolbar-title',[_c('h1',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('blogTitle'))}}),_vm._v(" "),_c('h2',{staticClass:"title"},[_c('router-link',{attrs:{"to":"/"},domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('blogTagline'))}})],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{staticClass:"no-color",attrs:{"to":"/","title":_vm.$store.getters.getLangKey('home')}},[_c('v-icon',{staticClass:"ml-3 mr-3"},[_vm._v("home")])],1),_vm._v(" "),(_vm.sidebar.items.infoBox)?_c('router-link',{staticClass:"no-color mr-2",attrs:{"to":(_vm.pageTopSlug + "/" + (_vm.infoBoxData.slug)),"title":_vm.$store.getters.getLangKey('aboutMe')}},[_c('v-icon',[_vm._v("account_box")])],1):_vm._e(),_vm._v(" "),(_vm.contactPage && _vm.contactPage.includes('http'))?_c('a',{staticClass:"no-color inline-flex",attrs:{"href":_vm.contactPage,"target":"_blank","title":_vm.$store.getters.getLangKey('contactMe')}},[_vm._v("\n    >\n      "),_c('v-icon',[_vm._v("email")])],1):(_vm.contactPage && !_vm.contactPage.includes('http'))?_c('router-link',{staticClass:"no-color ml-2",attrs:{"to":("" + _vm.pageTopSlug + _vm.contactPage)}},[_c('v-icon',[_vm._v("email")])],1):_vm._e(),_vm._v(" "),(_vm.right)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('v-container',[_c('announcements-bar'),_vm._v(" "),_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-right"},[_vm._v("\n          © 2006-"+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":_vm.$store.state.domain},domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('blogTagline'))}})])])],1)],1),_vm._v(" "),_c('loading-overlay'),_vm._v(" "),_c('social-bar'),_vm._v(" "),_c('cookie-consent-bar',{attrs:{"ok":"Dismiss","view":"Policy","days":"14","page":"cookie-policy-for-this-blog","cookie":_vm.$store.state.consentCookieName,"message":_vm.$store.getters.getLangKey('cookieConsentMessage')}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LatestPosts.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LatestPosts = ({
  name: 'LatestPosts',
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      posts: this.$store.state.bootstrapData.recentPosts || [],
      baseColor: this.$store.state.baseColor,
      images: ['javascript', 'html', 'css', 'code', 'angular']
    };
  },

  methods: {
    /**
     * Get a ramdom image if there is no attachment in the DTO
     * @method getRandomImage
     * @param {Array} attachments
     * @return {String}
     * **/
    getRandomImage: function getRandomImage(attachments) {
      var images = this.images;
      var random = images[Math.floor(Math.random() * images.length)];
      var url = attachments.length ? attachments[0].url : 'https://loremflickr.com/320/240/' + random;
      return url;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e0ce310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LatestPosts.vue
var LatestPosts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.posts),function(post,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm6":"","lg4":""}},[_c('v-card',{staticClass:"elevation-8 ma-1 post-card"},[_c('v-card-media',{attrs:{"src":_vm.getRandomImage(post.attachments),"height":"160"}}),_vm._v(" "),_c('v-card-title',{staticClass:"pb-0",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"post-card-title subheading ma-0 grey--text text--darken-1",domProps:{"innerHTML":_vm._s(post.title)}})])]),_vm._v(" "),_c('v-card-text',{staticClass:"pb-0 post-excerpt",domProps:{"innerHTML":_vm._s(_vm.cap(post.excerpt))}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"raised":"","color":_vm.baseColor,"block":"","router":"","to":_vm.createPostUrl(post.date, post.slug)},domProps:{"innerHTML":_vm._s(_vm.$store.getters.getLangKey('readFullPost'))}})],1)],1)],1)})),_vm._v(" "),_c('v-layout',[_c('v-flex',[_c('vue-adsense',{attrs:{"ad-slot":"8238948290","ad-format":"auto"}})],1)],1)],1)}
var LatestPosts_staticRenderFns = []
var LatestPosts_esExports = { render: LatestPosts_render, staticRenderFns: LatestPosts_staticRenderFns }
/* harmony default export */ var components_LatestPosts = (LatestPosts_esExports);
// CONCATENATED MODULE: ./src/components/LatestPosts.vue
function LatestPosts_injectStyle (ssrContext) {
  __webpack_require__("2vJy")
}
var LatestPosts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LatestPosts___vue_template_functional__ = false
/* styles */
var LatestPosts___vue_styles__ = LatestPosts_injectStyle
/* scopeId */
var LatestPosts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LatestPosts___vue_module_identifier__ = null
var LatestPosts_Component = LatestPosts_normalizeComponent(
  LatestPosts,
  components_LatestPosts,
  LatestPosts___vue_template_functional__,
  LatestPosts___vue_styles__,
  LatestPosts___vue_scopeId__,
  LatestPosts___vue_module_identifier__
)

/* harmony default export */ var src_components_LatestPosts = (LatestPosts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/HomePage.vue
//
//
//




/* harmony default export */ var HomePage = ({
  name: 'HomePage',
  components: {
    LatestPosts: src_components_LatestPosts
  },
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      show: this.$store.state.homePageContents
    };
  },
  mounted: function mounted() {
    var showOnHomePage = this.$store.state.homePageContents;
    if (showOnHomePage !== 'latest-posts' && showOnHomePage.includes('redirect:')) {
      // "homePageContents": "redirect:page-slug",
      var page = showOnHomePage.split(':')[1];
      this.$router.push({
        path: this.$store.state.pageTopSlug + '/' + page
      });
    } else {
      // "homePageContents": "latest-posts",
      this.show = showOnHomePage;
      this.setTitle();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7993183a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HomePage.vue
var HomePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show === 'latest-posts')?_c('latest-posts'):_vm._e()}
var HomePage_staticRenderFns = []
var HomePage_esExports = { render: HomePage_render, staticRenderFns: HomePage_staticRenderFns }
/* harmony default export */ var pages_HomePage = (HomePage_esExports);
// CONCATENATED MODULE: ./src/pages/HomePage.vue
var HomePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HomePage___vue_template_functional__ = false
/* styles */
var HomePage___vue_styles__ = null
/* scopeId */
var HomePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HomePage___vue_module_identifier__ = null
var HomePage_Component = HomePage_normalizeComponent(
  HomePage,
  pages_HomePage,
  HomePage___vue_template_functional__,
  HomePage___vue_styles__,
  HomePage___vue_scopeId__,
  HomePage___vue_module_identifier__
)

/* harmony default export */ var src_pages_HomePage = (HomePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TagsList.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TagsList = ({
  name: 'TagsList',
  props: ['tags']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-601469c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsList.vue
var TagsList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.tags),function(tag,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":("/tag/" + (tag.slug))},domProps:{"innerHTML":_vm._s(tag.title)}}),(index < _vm.tags.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()],1)}))}
var TagsList_staticRenderFns = []
var TagsList_esExports = { render: TagsList_render, staticRenderFns: TagsList_staticRenderFns }
/* harmony default export */ var components_TagsList = (TagsList_esExports);
// CONCATENATED MODULE: ./src/components/TagsList.vue
var TagsList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagsList___vue_template_functional__ = false
/* styles */
var TagsList___vue_styles__ = null
/* scopeId */
var TagsList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TagsList___vue_module_identifier__ = null
var TagsList_Component = TagsList_normalizeComponent(
  TagsList,
  components_TagsList,
  TagsList___vue_template_functional__,
  TagsList___vue_styles__,
  TagsList___vue_scopeId__,
  TagsList___vue_module_identifier__
)

/* harmony default export */ var src_components_TagsList = (TagsList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CategoriesList.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CategoriesList = ({
  name: 'CategoriesList',
  props: ['categories']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84dc0764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoriesList.vue
var CategoriesList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.categories),function(category,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":("/category/" + (category.slug))},domProps:{"innerHTML":_vm._s(category.title)}}),(index < _vm.categories.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()],1)}))}
var CategoriesList_staticRenderFns = []
var CategoriesList_esExports = { render: CategoriesList_render, staticRenderFns: CategoriesList_staticRenderFns }
/* harmony default export */ var components_CategoriesList = (CategoriesList_esExports);
// CONCATENATED MODULE: ./src/components/CategoriesList.vue
var CategoriesList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CategoriesList___vue_template_functional__ = false
/* styles */
var CategoriesList___vue_styles__ = null
/* scopeId */
var CategoriesList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CategoriesList___vue_module_identifier__ = null
var CategoriesList_Component = CategoriesList_normalizeComponent(
  CategoriesList,
  components_CategoriesList,
  CategoriesList___vue_template_functional__,
  CategoriesList___vue_styles__,
  CategoriesList___vue_scopeId__,
  CategoriesList___vue_module_identifier__
)

/* harmony default export */ var src_components_CategoriesList = (CategoriesList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PostDetails.vue
//
//
//
//
//
//
//




/* harmony default export */ var PostDetails = ({
  name: 'PostDetails',
  components: {
    TagsList: src_components_TagsList,
    CategoriesList: src_components_CategoriesList
  },
  props: ['page']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02faa552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostDetails.vue
var PostDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption grey--text text--darken-1 pt-0 pb-3"},[_vm._v("\n  Posted in "),_c('categories-list',{attrs:{"categories":_vm.page.categories}}),_vm._v(" and tagged\n  "),_c('tags-list',{attrs:{"tags":_vm.page.tags}}),_vm._v(" on "+_vm._s(_vm._f("formatDate")(_vm.page.date))+" by\n  "),_c('router-link',{attrs:{"to":("/author/" + (_vm.page.author.slug))},domProps:{"innerHTML":_vm._s(_vm.page.author.name)}})],1)}
var PostDetails_staticRenderFns = []
var PostDetails_esExports = { render: PostDetails_render, staticRenderFns: PostDetails_staticRenderFns }
/* harmony default export */ var components_PostDetails = (PostDetails_esExports);
// CONCATENATED MODULE: ./src/components/PostDetails.vue
var PostDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PostDetails___vue_template_functional__ = false
/* styles */
var PostDetails___vue_styles__ = null
/* scopeId */
var PostDetails___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PostDetails___vue_module_identifier__ = null
var PostDetails_Component = PostDetails_normalizeComponent(
  PostDetails,
  components_PostDetails,
  PostDetails___vue_template_functional__,
  PostDetails___vue_styles__,
  PostDetails___vue_scopeId__,
  PostDetails___vue_module_identifier__
)

/* harmony default export */ var src_components_PostDetails = (PostDetails_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/data/Lang.js
/**
 * Language file for reusable string,
 * available application-wide
 * **/
var Lang = {
  blogTitle: 'HTML5, CSS3 and JavaScript', // Main title of the blog
  blogTagline: 'The Fine Art of Web Development by Martin Ivanov', // blog headline
  previousPost: 'Previous Post', // Label for the "Previous Post" button
  nextPost: 'Next Post', // Label for the "Next Post" button
  readFullPost: 'Continue reading...', // Label for the "Continue reading" button
  resultsPerPage: 'Results per page', // Label for the "Results per page" drop down on the search page
  home: 'Home', // Tooltip for the "home" button on the main toolbar
  aboutMe: 'About me', // Tooltip for the "about" button on the main toolbar
  searchResultsForTitle: 'Search results for', // Search results for...
  dateFormat: 'MMMM D, YYYY', // Default date format for display
  categories: 'Categories', // Categories title
  categoryArchives: 'Category Archives', // Categories archive title
  tagArchives: 'Tag Archives', // Tag archives title
  tags: 'Tags', // Tags title
  contactMe: 'Get in touch', // Tooltip for the "contact" button on the main toolbar
  cookieConsentMessage: 'I use cookies to ensure you get the best experience', // Message displayed in the cookies consent bar
  sitemapGeneratorPageTitle: 'Sitemap Generator', // /sitemap-generator page slug,
  latestPosts: 'Recent Posts' // Latest posts headline
};

/* harmony default export */ var data_Lang = (Lang);
// CONCATENATED MODULE: ./src/helpers/Filters.js




/**
 * Format a date string to human-readable string
 * @filter formatDate
 * @param {DateString} date
 * @return {String}
 */
vue_esm["a" /* default */].filter('formatDate', function (date) {
  if (date) {
    return moment_default()(String(date)).format(data_Lang.dateFormat);
  }
});

/* harmony default export */ var Filters = (vue_esm["a" /* default */].filter);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/TagPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var TagPage = ({
  name: 'TagPage',
  mixins: [helpers_Mixins],
  components: {
    TagsList: src_components_TagsList,
    CategoriesList: src_components_CategoriesList,
    PostDetails: src_components_PostDetails
  },
  data: function data() {
    return {
      tags: this.$store.getters.tags.sort(function (a, b) {
        return b.post_count - a.post_count;
      }),
      baseColor: this.$store.state.baseColor,
      isList: true,
      pages: []
    };
  },

  watch: {
    '$route.params.id': function $routeParamsId() {
      this.getId();
    }
  },
  mounted: function mounted() {
    this.getId();
  },

  methods: {
    getId: function getId() {
      var _this = this;

      this.id = this.$route.params.id;
      var store = this.$store;
      if (!this.id) {
        // list all tags
        this.isList = true;
        this.setTitle(store.getters.getLangKey('tags'));
      } else {
        var getters = store.getters;
        var base = getters.apiProxyUrl;
        var resource = 'get_tag_posts';
        var tagSlug = this.id;
        var url = base + '?resource=' + resource + '&tag_slug=' + tagSlug;
        this.isList = false;
        var ajax = store.state.events.ajax;
        var cachedTag = getters.tag(this.id);
        if (cachedTag) {
          this.pages = cachedTag;
          this.setTitle(this.id);
          return;
        }
        this.$root.$emit(ajax, true);
        this.$http(url).then(function (response) {
          response = response.data;
          if (!response) {
            _this.to404();
            return;
          }
          _this.pages = response.posts;
          _this.$store.commit('setTag', {
            slug: _this.id,
            pages: _this.pages
          });
          _this.setTitle(response.tag.title);
          _this.$root.$emit(ajax, false);
        });
      }
    },

    /**
     * @using ../../filters
     */
    formatDate: function formatDate() {
      return Filters.formatDate();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae3fb8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/TagPage.vue
var TagPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('h3',{staticClass:"headline grey--text text--darken-1 pt-3 pb-3"},[(_vm.isList)?_c('span',[_vm._v("Tags")]):_c('router-link',{staticClass:"grey--text text--darken-2 no-decoration",attrs:{"to":"/tag"}},[_vm._v("\n      "+_vm._s(_vm.$store.getters.getLangKey('tagArchives'))+": \""+_vm._s(this.id)+"\" ("+_vm._s(_vm.pages.length)+" posts)\n    ")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('vue-adsense',{attrs:{"ad-slot":"2619967717","ad-format":"auto"}})],1)],1),_vm._v(" "),(_vm.isList)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.tags),function(tag,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm3":"","lg3":""}},[_c('v-card',[_c('v-card-actions',[_c('v-btn',{staticClass:"opaque-btn cat-tag-label-btn",style:({opacity: _vm.setOpacity(tag.post_count)}),attrs:{"router":"","block":"","raised":"","ripple":"","color":_vm.baseColor,"to":("/tag/" + (tag.slug)),"title":tag.slug},domProps:{"innerHTML":_vm._s(((tag.slug) + " (" + (tag.post_count) + ")"))}})],1)],1)],1)})):_vm._l((_vm.pages),function(page,index){return _c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h4',{staticClass:"subheading pt-1 pb-1"},[_c('router-link',{staticClass:"grey--text text--darken-2",attrs:{"to":_vm.createPostUrl(page.date, page.slug)},domProps:{"innerHTML":_vm._s(page.title_plain)}})],1),_vm._v(" "),_c('p',{attrs:{"html":"grey--text text--darken-2"},domProps:{"innerHTML":_vm._s(_vm.sanitize(page.excerpt))}}),_vm._v(" "),_c('post-details',{attrs:{"page":page}})],1)],1)})],2)}
var TagPage_staticRenderFns = []
var TagPage_esExports = { render: TagPage_render, staticRenderFns: TagPage_staticRenderFns }
/* harmony default export */ var pages_TagPage = (TagPage_esExports);
// CONCATENATED MODULE: ./src/pages/TagPage.vue
var TagPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TagPage___vue_template_functional__ = false
/* styles */
var TagPage___vue_styles__ = null
/* scopeId */
var TagPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TagPage___vue_module_identifier__ = null
var TagPage_Component = TagPage_normalizeComponent(
  TagPage,
  pages_TagPage,
  TagPage___vue_template_functional__,
  TagPage___vue_styles__,
  TagPage___vue_scopeId__,
  TagPage___vue_module_identifier__
)

/* harmony default export */ var src_pages_TagPage = (TagPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/CategoryPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var CategoryPage = ({
  name: 'CategoryPage',
  mixins: [helpers_Mixins],
  components: {
    TagsList: src_components_TagsList,
    CategoriesList: src_components_CategoriesList,
    PostDetails: src_components_PostDetails
  },
  data: function data() {
    return {
      categories: this.$store.getters.categories.sort(function (a, b) {
        return b.post_count - a.post_count;
      }),
      baseColor: this.$store.state.baseColor,
      isList: true,
      pages: []
    };
  },

  watch: {
    '$route.params.id': function $routeParamsId() {
      this.getId();
    }
  },
  mounted: function mounted() {
    this.getId();
  },

  methods: {
    getId: function getId() {
      var _this = this;

      this.id = this.$route.params.id;
      var store = this.$store;
      if (!this.id) {
        // list all categories
        this.isList = true;
        this.setTitle(store.getters.getLangKey('categories'));
      } else {
        var getters = store.getters;
        var base = getters.apiProxyUrl;
        var resource = 'get_category_posts';
        var categorySlug = this.id;
        var url = base + '?resource=' + resource + '&category_slug=' + categorySlug;
        this.isList = false;
        var ajax = store.state.events.ajax;
        var cachedCategory = store.getters.category(this.id);
        if (cachedCategory) {
          this.pages = cachedCategory;
          this.setTitle(this.id);
          return;
        }
        this.$root.$emit(ajax, true);
        this.$http(url).then(function (response) {
          response = response.data;
          if (!response) {
            _this.to404();
            return;
          }
          _this.pages = response.posts;
          _this.$store.commit('setCategory', {
            slug: _this.id,
            pages: _this.pages
          });
          _this.setTitle(response.category.title);
          _this.$root.$emit(ajax, false);
        });
      }
    },

    /**
     * @using ../../filters
     */
    formatDate: function formatDate() {
      return Filters.formatDate();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c60b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CategoryPage.vue
var CategoryPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('h3',{staticClass:"headline grey--text text--darken-1 pt-3 pb-3"},[(_vm.isList)?_c('span',[_vm._v("Categories")]):_c('router-link',{staticClass:"grey--text text--darken-2 no-decoration",attrs:{"to":"/category"}},[_vm._v("\n      "+_vm._s(_vm.$store.getters.getLangKey('categoryArchives'))+": \""+_vm._s(this.id)+"\" ("+_vm._s(_vm.pages.length)+" posts)\n    ")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"row":"","wrap":""}},[_c('vue-adsense',{attrs:{"ad-slot":"1372612451","ad-format":"auto"}})],1)],1),_vm._v(" "),(_vm.isList)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.categories),function(category,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm3":"","lg3":""}},[_c('v-card',[_c('v-card-actions',[_c('v-btn',{staticClass:"opaque-btn cat-tag-label-btn",style:({opacity: _vm.setOpacity(category.post_count)}),attrs:{"router":"","block":"","raised":"","ripple":"","color":_vm.baseColor,"title":category.slug,"to":("/category/" + (category.slug))},domProps:{"innerHTML":_vm._s(((category.slug) + " (" + (category.post_count) + ")"))}})],1)],1)],1)})):_vm._l((_vm.pages),function(page,index){return _c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h4',{staticClass:"subheading pt-1 pb-1"},[_c('router-link',{staticClass:"grey--text text--darken-2",attrs:{"to":_vm.createPostUrl(page.date, page.slug)},domProps:{"innerHTML":_vm._s(page.title_plain)}})],1),_vm._v(" "),_c('p',{attrs:{"html":"grey--text text--darken-2"},domProps:{"innerHTML":_vm._s(_vm.sanitize(page.excerpt))}}),_vm._v(" "),_c('post-details',{attrs:{"page":page}})],1)],1)})],2)}
var CategoryPage_staticRenderFns = []
var CategoryPage_esExports = { render: CategoryPage_render, staticRenderFns: CategoryPage_staticRenderFns }
/* harmony default export */ var pages_CategoryPage = (CategoryPage_esExports);
// CONCATENATED MODULE: ./src/pages/CategoryPage.vue
var CategoryPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CategoryPage___vue_template_functional__ = false
/* styles */
var CategoryPage___vue_styles__ = null
/* scopeId */
var CategoryPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CategoryPage___vue_module_identifier__ = null
var CategoryPage_Component = CategoryPage_normalizeComponent(
  CategoryPage,
  pages_CategoryPage,
  CategoryPage___vue_template_functional__,
  CategoryPage___vue_styles__,
  CategoryPage___vue_scopeId__,
  CategoryPage___vue_module_identifier__
)

/* harmony default export */ var src_pages_CategoryPage = (CategoryPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageView.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PageView = ({
  name: 'PageView',
  props: ['page']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c8c6f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageView.vue
var PageView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"headline grey--text text--darken-1 pt-3 pb-3",domProps:{"innerHTML":_vm._s(_vm.page.title_plain)}}),_vm._v(" "),(_vm.$route.name !== 'PagePage')?_c('div',{staticClass:"grey--text text--darken-1 pb-3 caption"},[_vm._v("Posted by\n        "),_c('router-link',{attrs:{"to":("/author/" + (_vm.page.author.slug))},domProps:{"innerHTML":_vm._s(_vm.page.author.name)}}),_vm._v(" on "+_vm._s(_vm._f("formatDate")(_vm.page.date))+"\n      ")],1):_vm._e(),_vm._v(" "),_c('vue-adsense',{attrs:{"ad-slot":"6676910020","ad-format":"auto"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})],1)],1)],1)}
var PageView_staticRenderFns = []
var PageView_esExports = { render: PageView_render, staticRenderFns: PageView_staticRenderFns }
/* harmony default export */ var components_PageView = (PageView_esExports);
// CONCATENATED MODULE: ./src/components/PageView.vue
var PageView_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PageView___vue_template_functional__ = false
/* styles */
var PageView___vue_styles__ = null
/* scopeId */
var PageView___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageView___vue_module_identifier__ = null
var PageView_Component = PageView_normalizeComponent(
  PageView,
  components_PageView,
  PageView___vue_template_functional__,
  PageView___vue_styles__,
  PageView___vue_scopeId__,
  PageView___vue_module_identifier__
)

/* harmony default export */ var src_components_PageView = (PageView_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PostPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var PostPage = ({
  name: 'PostPage',
  mixins: [helpers_Mixins],
  components: {
    TagsList: src_components_TagsList,
    CategoriesList: src_components_CategoriesList,
    PageView: src_components_PageView,
    PostDetails: src_components_PostDetails
  },
  data: function data() {
    return {
      resource: '?resource=get_post&post_slug=',
      page: null,
      href: window.location.href,
      baseColor: this.$store.state.baseColor
    };
  },

  watch: {
    '$route.params.id': function $routeParamsId() {
      this.getPostData();
    }
  },
  mounted: function mounted() {
    this.getPostData();
  },
  updated: function updated() {
    this.setTitle(this.page.post.title_plain);
  },

  methods: {
    /**
     * Get, set and cache the post DTO
     * @method getPostData
     * @return void
     * **/
    getPostData: function getPostData() {
      var _this = this;

      var store = this.$store;
      var getters = store.getters;
      var base = getters.apiProxyUrl;
      var id = this.$route.params.id;
      var slug = '' + this.resource + id;
      var url = '' + base + slug;
      var page = getters.post(id);
      var ajax = store.state.events.ajax;
      if (page) {
        this.page = page;
        return;
      }
      this.$root.$emit(ajax, true);
      this.$http(url).then(function (response) {
        response = response.data;
        store.commit('storePost', response);
        _this.page = getters.post(id);
        _this.$root.$emit(ajax, false);
      });
    },

    /**
     * @using ../../filters
     */
    formatDate: function formatDate() {
      return Filters.formatDate();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0771cc6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PostPage.vue
var PostPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',[_c('page-view',{attrs:{"page":_vm.page.post}}),_vm._v(" "),_c('post-details',{attrs:{"page":_vm.page.post}}),_vm._v(" "),_c('v-toolbar',{attrs:{"dense":""}},[(_vm.page.previous_url)?_c('v-btn',{attrs:{"raised":"","router":"","ripple":"","color":_vm.baseColor,"title":_vm.$store.getters.getLangKey('previousPost'),"to":{name: 'PostPage', params: _vm.createRouteFromUrl(_vm.page.previous_url)}}},[_c('v-icon',[_vm._v("chevron_left")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.page.next_url)?_c('v-btn',{attrs:{"raised":"","router":"","ripple":"","color":_vm.baseColor,"title":_vm.$store.getters.getLangKey('nextPost'),"to":{name: 'PostPage', params: _vm.createRouteFromUrl(_vm.page.next_url)}}},[_c('v-icon',[_vm._v("chevron_right")])],1):_vm._e()],1)],1):_vm._e()}
var PostPage_staticRenderFns = []
var PostPage_esExports = { render: PostPage_render, staticRenderFns: PostPage_staticRenderFns }
/* harmony default export */ var pages_PostPage = (PostPage_esExports);
// CONCATENATED MODULE: ./src/pages/PostPage.vue
var PostPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PostPage___vue_template_functional__ = false
/* styles */
var PostPage___vue_styles__ = null
/* scopeId */
var PostPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PostPage___vue_module_identifier__ = null
var PostPage_Component = PostPage_normalizeComponent(
  PostPage,
  pages_PostPage,
  PostPage___vue_template_functional__,
  PostPage___vue_styles__,
  PostPage___vue_scopeId__,
  PostPage___vue_module_identifier__
)

/* harmony default export */ var src_pages_PostPage = (PostPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/PagePage.vue
//
//
//
//
//




/* harmony default export */ var PagePage = ({
  name: 'PagePage',
  components: {
    PageView: src_components_PageView
  },
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      page: {}
    };
  },

  watch: {
    '$route.params.slug': function $routeParamsSlug() {
      this.getPageData();
    }
  },
  mounted: function mounted() {
    this.getPageData();
  },

  methods: {
    /**
     * Get, set and cache the page DTO
     * @method getPageData
     * @return void
     * **/
    getPageData: function getPageData() {
      var _this = this;

      var store = this.$store;
      var getters = store.getters;
      var slug = this.$route.path.split('/')[2];
      var page = getters.page(slug);
      if (page) {
        this.page = page;
        this.setTitle(this.page.title_plain);
      } else {
        var ajax = store.state.events.ajax;
        var base = getters.apiProxyUrl;
        var resource = 'get_page';
        var url = base + '/?resource=' + resource + '&page_slug=' + slug;
        this.$root.$emit(ajax, true);
        this.$http(url).then(function (response) {
          response = response.data.page;
          if (!response) {
            _this.to404();
            return;
          }
          store.commit('setPage', response);
          _this.page = getters.page(slug);
          _this.$root.$emit(ajax, false);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b371440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PagePage.vue
var PagePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-view',{attrs:{"page":_vm.page}})],1)}
var PagePage_staticRenderFns = []
var PagePage_esExports = { render: PagePage_render, staticRenderFns: PagePage_staticRenderFns }
/* harmony default export */ var pages_PagePage = (PagePage_esExports);
// CONCATENATED MODULE: ./src/pages/PagePage.vue
var PagePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PagePage___vue_template_functional__ = false
/* styles */
var PagePage___vue_styles__ = null
/* scopeId */
var PagePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PagePage___vue_module_identifier__ = null
var PagePage_Component = PagePage_normalizeComponent(
  PagePage,
  pages_PagePage,
  PagePage___vue_template_functional__,
  PagePage___vue_styles__,
  PagePage___vue_scopeId__,
  PagePage___vue_module_identifier__
)

/* harmony default export */ var src_pages_PagePage = (PagePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/NotFound.vue
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var NotFound = ({
  name: 'NotFound',
  components: {
    SearchForm: src_components_SearchForm
  },
  mixins: [helpers_Mixins],
  mounted: function mounted() {
    this.setTitle('Page not found');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1a92e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"title grey--text text--darken-1 pt-0 pb-3"},[_vm._v("Bummer... The requested page could not be found.")]),_vm._v(" "),_c('p',[_vm._v("Maybe go to my "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("home")]),_vm._v(" page or try search?")],1),_vm._v(" "),_c('search-form')],1)],1)],1)}
var NotFound_staticRenderFns = []
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var pages_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/pages/NotFound.vue
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = null
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  pages_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var src_pages_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/SearchResults.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var SearchResults = ({
  name: 'SearchResults',
  mixins: [helpers_Mixins],
  components: {
    SearchForm: src_components_SearchForm
  },
  data: function data() {
    return {
      query: null,
      resource: function resource(count, page, search) {
        return '?resource=get_search_results&count=' + count + '&page=' + page + '&search=' + search;
      },

      itemsPerPageDropdown: [5, 10, 15, 20, 25, 30],
      pageTopSlug: this.$store.state.pageTopSlug,
      resultsPerPage: null,
      result: null,
      page: 1
    };
  },

  watch: {
    '$route.params.query': function $routeParamsQuery() {
      this.getSearchResults();
    },
    '$route.params.page': function $routeParamsPage() {
      this.getSearchResults();
    }
  },
  mounted: function mounted() {
    this.resultsPerPage = this.itemsPerPageDropdown[1];
    this.getSearchResults();
  },

  methods: {
    /**
     * Go to URL on pager click
     * @method goTo
     * @return {void}
     */
    goTo: function goTo() {
      this.$router.push({
        path: '/search/' + this.page + '/' + this.query
      });
    },

    /**
     * Get the search results DTO from the API
     * @method getSearchResults
     * @return {void}
     */
    getSearchResults: function getSearchResults() {
      var _this = this;

      this.query = this.$route.params.query;
      this.page = parseInt(this.$route.params.page, 10);
      var store = this.$store;
      var getters = store.getters;
      var ajax = store.state.events.ajax;
      var base = getters.apiProxyUrl;
      var url = '' + base + this.resource(this.resultsPerPage, this.page, this.query);
      this.$root.$emit(ajax, true);
      this.$http.post(url).then(function (response) {
        _this.result = response.data;
        _this.setTitle(getters.getLangKey('searchResultsForTitle') + ' "' + _this.query + '"');
        _this.$root.$emit(ajax, false);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0919d9fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SearchResults.vue
var SearchResults_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result)?_c('v-container',{staticClass:"search-results",attrs:{"fluid":"","grid-list-sm":""}},[(_vm.result.posts.length)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"title grey--text text--darken-1 pt-0"},[_vm._v("\n        Found "),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.result.count_total)}}),_vm._v("\n        results for \""),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.query)}}),_vm._v("\"\n      ")])]),_vm._v(" "),_c('v-flex',[_c('div',{staticClass:"text-lg-right text-md-right text-sm-right text-xs-right",domProps:{"innerHTML":_vm._s(((_vm.$store.getters.getLangKey('resultsPerPage')) + ":"))}}),_vm._v(" "),_c('div',{staticClass:"text-lg-right text-md-right text-sm-right text-xs-right"},[_c('v-select',{staticClass:"results-per-page-dropdown pt-0",attrs:{"items":_vm.itemsPerPageDropdown},on:{"input":function($event){_vm.getSearchResults()}},model:{value:(_vm.resultsPerPage),callback:function ($$v) {_vm.resultsPerPage=$$v},expression:"resultsPerPage"}})],1)])],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"title grey--text text--darken-1 pt-0"},[_vm._v("Nothing found\n        for \""),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.query)}}),_vm._v("\". Maybe try another serach?")]),_vm._v(" "),_c('search-form')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('vue-adsense',{attrs:{"ad-slot":"9213118610","ad-format":"auto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('ol',_vm._l((_vm.result.posts),function(item,index){return _c('li',{key:index},[_c('h3',{staticClass:"subheading pt-1 pb-1"},[_c('v-chip',{staticClass:"ml-0",attrs:{"label":""}},[_vm._v(_vm._s(item.type.toUpperCase()))]),_vm._v(" "),(item.type === 'post')?_c('router-link',{staticClass:"grey--text text--darken-2",attrs:{"to":_vm.createPostUrl(item.date, item.slug)}},[_vm._v(_vm._s(item.title_plain))]):_c('router-link',{staticClass:"grey--text text--darken-2",attrs:{"to":(_vm.pageTopSlug + "/" + (item.slug))}},[_vm._v(_vm._s(item.title_plain))])],1),_vm._v(" "),_c('p',{staticClass:"grey--text text--darken-2",domProps:{"innerHTML":_vm._s(_vm.cap(item.excerpt))}}),_vm._v(" "),(item.type === 'post')?_c('div',{domProps:{"innerHTML":_vm._s(("" + (_vm.$store.state.domain) + (_vm.createPostUrl(item.date, item.slug))))}}):_c('div',{domProps:{"innerHTML":_vm._s(("" + (_vm.$store.state.domain) + _vm.pageTopSlug + "/" + (item.slug)))}})])}))])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[(_vm.result.posts.length)?_c('div',{staticClass:"text-xs-center"},[_c('v-pagination',{attrs:{"router":"","color":_vm.$store.state.baseColor,"length":_vm.result.pages},on:{"input":function($event){_vm.goTo()}},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1):_vm._e()])],1)],1):_vm._e()}
var SearchResults_staticRenderFns = []
var SearchResults_esExports = { render: SearchResults_render, staticRenderFns: SearchResults_staticRenderFns }
/* harmony default export */ var pages_SearchResults = (SearchResults_esExports);
// CONCATENATED MODULE: ./src/pages/SearchResults.vue
function SearchResults_injectStyle (ssrContext) {
  __webpack_require__("NU3e")
}
var SearchResults_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SearchResults___vue_template_functional__ = false
/* styles */
var SearchResults___vue_styles__ = SearchResults_injectStyle
/* scopeId */
var SearchResults___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchResults___vue_module_identifier__ = null
var SearchResults_Component = SearchResults_normalizeComponent(
  SearchResults,
  pages_SearchResults,
  SearchResults___vue_template_functional__,
  SearchResults___vue_styles__,
  SearchResults___vue_scopeId__,
  SearchResults___vue_module_identifier__
)

/* harmony default export */ var src_pages_SearchResults = (SearchResults_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/SiteMapGenerator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SiteMapGenerator = ({
  name: 'SiteMapGenerator',
  mixins: [helpers_Mixins],
  data: function data() {
    return {
      items: [],
      sitemap: '',
      title: this.$store.getters.getLangKey('sitemapGeneratorPageTitle')
    };
  },
  mounted: function mounted() {
    var _this = this;

    var store = this.$store;
    var state = store.state;
    var ajax = state.events.ajax;
    var bootstrap = state.bootstrapData;
    var domain = state.domain;
    var apiProxyUrl = state.apiProxyUrl;
    var unlimitedPostsLimit = state.unlimitedPostsLimit;
    var sitemap = [];
    var items = [];
    this.$root.$emit(ajax, true);
    this.$http(apiProxyUrl + '?resource=get_posts&count=' + unlimitedPostsLimit).then(function (response) {
      response = response.data;
      response.posts.forEach(function (post) {
        items.push(domain + '/' + _this.removeDomainFromUrl(post.url));
      });
      bootstrap.tags.forEach(function (tag) {
        items.push(domain + '/tag/' + tag.slug);
      });
      bootstrap.categories.forEach(function (category) {
        items.push(domain + '/category/' + category.slug);
      });
      _this.$http(apiProxyUrl + '?resource=get_author_posts&slug=' + state.author + '&count=' + unlimitedPostsLimit + '&post_type=page').then(function (response) {
        response = response.data;
        response.posts.forEach(function (page) {
          items.push('' + domain + state.pageTopSlug + '/' + page.slug);
        });
        items.forEach(function (item) {
          sitemap.push('\n\t<url>\n\t\t<loc>' + item + '</loc>\n\t\t<changefreq>daily</changefreq>\n\t\t<priority>1.0</priority>\n\t</url>');
        });
        sitemap.unshift('<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">');
        sitemap.push('\n</urlset>');
        _this.sitemap = sitemap.join('');
        _this.items = items;
        _this.setTitle(_this.title);
        _this.$root.$emit(ajax, false);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5159130","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SiteMapGenerator.vue
var SiteMapGenerator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('h3',{staticClass:"headline grey--text text--darken-1 pt-0 pb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.items.length)?_c('div',[_c('h4',{staticClass:"title grey--text text--darken-1 pt-3 pb-3"},[_vm._v("HTML Sitemap ("+_vm._s(_vm.items.length)+" items)")]),_vm._v(" "),_c('ol',{staticClass:"inside-list"},_vm._l((_vm.items),function(item,index){return _c('li',{domProps:{"innerHTML":_vm._s(item)}})}))]):_vm._e(),_vm._v(" "),(_vm.sitemap)?_c('div',[_c('h4',{staticClass:"title grey--text text--darken-1 pt-3 pb-3"},[_vm._v("XML Sitemap")]),_vm._v(" "),_c('p',[_vm._v("Copy the below and save to "),_c('code',[_vm._v(_vm._s(_vm.$store.state.domain)+"/sitemap.xml")]),_vm._v(" file on your server.\n          Then register with "),_c('a',{attrs:{"href":"https://www.google.com/webmasters/tools/","target":"_blank"}},[_vm._v("\n            Google Search Console")]),_vm._v(".")]),_vm._v(" "),(_vm.sitemap)?_c('code',[_c('xmp',{domProps:{"innerHTML":_vm._s(_vm.sitemap)}})],1):_vm._e()]):_vm._e()])],1)],1)}
var SiteMapGenerator_staticRenderFns = []
var SiteMapGenerator_esExports = { render: SiteMapGenerator_render, staticRenderFns: SiteMapGenerator_staticRenderFns }
/* harmony default export */ var pages_SiteMapGenerator = (SiteMapGenerator_esExports);
// CONCATENATED MODULE: ./src/pages/SiteMapGenerator.vue
function SiteMapGenerator_injectStyle (ssrContext) {
  __webpack_require__("rWWX")
}
var SiteMapGenerator_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SiteMapGenerator___vue_template_functional__ = false
/* styles */
var SiteMapGenerator___vue_styles__ = SiteMapGenerator_injectStyle
/* scopeId */
var SiteMapGenerator___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SiteMapGenerator___vue_module_identifier__ = null
var SiteMapGenerator_Component = SiteMapGenerator_normalizeComponent(
  SiteMapGenerator,
  pages_SiteMapGenerator,
  SiteMapGenerator___vue_template_functional__,
  SiteMapGenerator___vue_styles__,
  SiteMapGenerator___vue_scopeId__,
  SiteMapGenerator___vue_module_identifier__
)

/* harmony default export */ var src_pages_SiteMapGenerator = (SiteMapGenerator_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// CONCATENATED MODULE: ./src/data/config.js
/**
 * Application main configuration file
 * This file controls many aspects of how the
 * app works and behaves
 * **/
var Config = {
  /**
   * Site domain
   * **/
  domain: 'https://martinivanov.net',
  /**
   * Path to api-proxy.php file
   * **/
  apiProxyUrl: 'https://api.martinivanov.net/api-proxy.php',
  /**
   * Google analytics key
   * **/
  googleAnalyticsKey: 'UA-17572030-16',
  /**
   * Google AdSense Client ID
   * **/
  googleAdSenseClientId: 'ca-pub-4259822914193810',
  /**
   * Blog author slug
   * **/
  author: 'acidmartin',
  /**
   * Site base color (check colors here: https://vuetifyjs.com/style/colors)
   * **/
  baseColor: 'grey darken-3 theme--dark',
  /**
   * Route for "page" types, like /page/page-type
   * **/
  pageTopSlug: '/page',
  /**
   * Contact page, used in the top bar link
   * You could use:
   * 1. Local page, like /contact (don't forget the leading slash)
   * 2. External page, like https://wemakesites.net/contact
   * 3. Leave blank (the button will not render)
   * **/
  contactPage: 'https://wemakesites.net/contact',
  /**
   * Slug for the page, which content is shown in the info box in the navigation bar
   * **/
  infoBoxPageSlug: 'about',
  /**
   * Number of the latest posts shown on the home page
   * **/
  homePagePostsCount: 12,
  /**
   * Set higher count in order to get all posts/pages, etc
   * **/
  unlimitedPostsLimit: 1000,
  /**
   * Do not show entries in the categories cloud if they contain equal
   * or less than categoriesCloudMinCount posts/pages
   * **/
  categoriesCloudMinCount: 5,
  /**
   * Do not show entries in the tag cloud if they contain equal
   * or less than tagCloudMinCount posts/pages
   * **/
  tagCloudMinCount: 5,
  /**
   * Cookie which is set when the "dismiss" button of the
   * cookie consent bar at the bottom has been clicked
   * **/
  consentCookieName: '_martinvanovnet_cookie_consent_read',
  /**
   * Contents of the home page
   * You can set:
   * 1. 'latest-posts' to display the latest posts
   * 2. 'redirect:page-slug' to redirect to a specific page
   * 3. 'page:page-slug' to show the contents of a specific page without redirecting
   * **/
  homePageContents: 'latest-posts',
  /**
   * Sidebar settings
   * **/
  sidebar: {
    position: 'left', // Position of the sidebar, 'left' or 'right'
    items: {
      searchBar: true, // Display the search bar
      infoBox: true, // Display the info box
      categoriesCloud: true, // Display the categories cloud
      tagCloud: true, // Display the tag cloud,
      latestPosts: true, // Display the latest blog posts
      customBoxes: [{
        heading: 'Vuecidity', // optional
        description: 'Vuecidity is a free, open source and licensed under MIT component library for the Vue.js framework, inspired by Google Material Design and Bootstrap', // optional
        imageHeight: 166, // optional height of the image in pixels, default is 200 pixels
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2018/03/vuecidity.png', // optional
        linkUrl: 'http://vuecidity.wemakesites.net/', // optional
        render: true // Display the box or not
      }, {
        heading: 'VueRibbon', // optional
        description: 'VueRibbon is a JavaScript, CSS3 and HTML5 implementation of the Microsoft Office ribbon control, built on top of Vue, Vuetify and ES6', // optional
        imageHeight: 166, // optional height of the image in pixels, default is 200 pixels
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2018/01/vue-ribbon.png', // optional
        linkUrl: 'https://vueribbon.com/', // optional
        render: true // Display the box or not
      }, {
        heading: 'Ribbon.JS', // optional
        description: 'Arguably the best recreation of the MS Officetm ribbon bar, using JavaScript, CSS3, and HTML5.', // optional
        imageHeight: 166, // optional height of the image in pixels, default is 200 pixels
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2017/12/ribbon.js.png', // optional
        linkUrl: 'http://ribbonjs.com/', // optional
        render: true // Display the box or not
      }, {
        heading: 'icons.io',
        description: 'Search, preview and use thousands of icons from Google Material Design, Font Awesome and more.',
        imageHeight: 166,
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2018/01/icons.io_.png',
        linkUrl: 'http://icons.wemakesites.net/',
        render: true
      }, {
        heading: 'Encyclopaedia Metallum API',
        description: 'Unofficial, third party RESTful API for Encyclopaedia Metallum.',
        imageHeight: 166,
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2016/11/em-api-thumb.png',
        linkUrl: 'http://em.wemakesites.net/',
        render: true
      }, {
        heading: 'Avid Eleven Rack Presets',
        description: 'The new sharing and community platform for Avid Eleven Rack presets and rigs.',
        imageHeight: 166,
        imageUrl: 'https://api.martinivanov.net/wp-content/uploads/2017/12/elevenrack.net_.png',
        linkUrl: 'http://elevenrack.net/',
        render: true
      }, {
        heading: 'HTML5, CSS3 and JavaScript Experiments and Insight',
        description: 'The demo website for the HTML5, CSS3 and JavaScript articles I\'ve been writing since 2006 here on my web-development blog.',
        linkUrl: 'http://experiments.wemakesites.net/',
        render: true
      }, {
        heading: 'Online Image to Base-64 Converter',
        description: 'HTML5-driven image to base-64 encoder.',
        linkUrl: 'http://image2base64.wemakesites.net/',
        render: true
      }],
      /**
       * Internal pages to show in a menu in the sidebar
       * **/
      pages: {
        heading: 'Menu', // Menu heading
        links: [{
          title: 'About Me', // Link label
          slug: 'about' // Link slug (do add leading slash)
        }, {
          title: 'Cookie Policy',
          slug: 'cookie-policy-for-this-blog'
        }]
      }
    }
  }
};

/* harmony default export */ var config = (Config);
// CONCATENATED MODULE: ./src/router/index.js







// import AuthorPage from '@/pages/AuthorPage'






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  name: 'HomePage',
  component: src_pages_HomePage
}, {
  path: '/sitemap-generator',
  component: src_pages_SiteMapGenerator
}, {
  path: '/author',
  redirect: '/404'
}, {
  path: '/search',
  redirect: '/404'
}, {
  path: '/search/:page',
  redirect: '/404'
}, {
  path: '/404',
  name: 'NotFound',
  component: src_pages_NotFound
}, {
  path: '/author/:id',
  redirect: '/page/about'
}, {
  path: '/tag',
  name: 'TagPage',
  component: src_pages_TagPage,
  children: [{
    path: ':id',
    component: src_pages_TagPage
  }]
}, {
  path: '/category',
  name: 'CategoryPage',
  component: src_pages_CategoryPage,
  children: [{
    path: ':id',
    component: src_pages_CategoryPage
  }]
}, {
  path: '/:year/:month/:day/:id',
  name: 'PostPage',
  component: src_pages_PostPage
}, {
  path: config.pageTopSlug,
  redirect: '/404'
}, {
  path: config.pageTopSlug + '/:slug',
  component: src_pages_PagePage,
  name: 'PagePage'
}, {
  path: '/search/:page/:query',
  name: 'SearchResults',
  component: src_pages_SearchResults
}];

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: routes,
  scrollBehavior: function scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: config.googleAnalyticsKey,
  router: router
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/vendor/vue-adsense/vue-adsense.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var vue_adsense = ({
  name: 'VueAdsense',
  data: function data() {
    return {
      adClient: this.$store.state.googleAdSenseClientId
    };
  },

  props: {
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    }
  },
  mounted: function mounted() {
    if (!document.getElementById('XuQnsBExZmfq')) {
      this.$store.commit('setAdBlockPlusEnabled');
    }
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090b0796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vendor/vue-adsense/vue-adsense.vue
var vue_adsense_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ins',{class:['adsbygoogle', 'vue-adsense', 'mb-3'],style:(_vm.adStyle),attrs:{"data-ad-client":_vm.adClient,"data-ad-slot":_vm.adSlot,"data-ad-format":_vm.adFormat}})])}
var vue_adsense_staticRenderFns = []
var vue_adsense_esExports = { render: vue_adsense_render, staticRenderFns: vue_adsense_staticRenderFns }
/* harmony default export */ var vue_adsense_vue_adsense = (vue_adsense_esExports);
// CONCATENATED MODULE: ./src/vendor/vue-adsense/vue-adsense.vue
var vue_adsense_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var vue_adsense___vue_template_functional__ = false
/* styles */
var vue_adsense___vue_styles__ = null
/* scopeId */
var vue_adsense___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vue_adsense___vue_module_identifier__ = null
var vue_adsense_Component = vue_adsense_normalizeComponent(
  vue_adsense,
  vue_adsense_vue_adsense,
  vue_adsense___vue_template_functional__,
  vue_adsense___vue_styles__,
  vue_adsense___vue_scopeId__,
  vue_adsense___vue_module_identifier__
)

/* harmony default export */ var vendor_vue_adsense_vue_adsense = (vue_adsense_Component.exports);

// CONCATENATED MODULE: ./src/vendor/vue-adsense/index.js


vendor_vue_adsense_vue_adsense.install = function install(Vue) {
  Vue.component(vendor_vue_adsense_vue_adsense.name, vendor_vue_adsense_vue_adsense);
};

/* harmony default export */ var vendor_vue_adsense = (vendor_vue_adsense_vue_adsense);
// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// EXTERNAL MODULE: ./src/App.css
var src_App_0 = __webpack_require__("Ue/Q");
var App_default = /*#__PURE__*/__webpack_require__.n(src_App_0);

// CONCATENATED MODULE: ./src/main.js













vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);
vue_esm["a" /* default */].use(vuetify_default.a);
vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);
vue_esm["a" /* default */].use(vendor_vue_adsense);

vue_esm["a" /* default */].config.productionTip = false;

/**
 * Vuex state store
 */
var store = new vuex_esm["a" /* default */].Store({
  state: {
    pages: {},
    domain: config.domain,
    apiProxyUrl: config.apiProxyUrl,
    baseColor: config.baseColor,
    bootstrapData: {
      recentPosts: [],
      tags: [],
      categories: [],
      infoBox: {}
    },
    events: {
      ajax: 'ajax',
      pageLoaded: 'page:loaded'
    },
    posts: {},
    lang: data_Lang,
    categories: {},
    tags: {},
    externalData: {},
    googleAdSenseClientId: config.googleAdSenseClientId,
    consentCookieName: config.consentCookieName,
    sidebar: config.sidebar,
    pageTopSlug: config.pageTopSlug,
    homePageContents: config.homePageContents,
    author: config.author,
    unlimitedPostsLimit: config.unlimitedPostsLimit,
    contactPage: config.contactPage,
    categoriesCloudMinCount: config.categoriesCloudMinCount,
    tagCloudMinCount: config.tagCloudMinCount,
    asyncConfig: '/static/data/async-config.json',
    adBlockPlusEnabled: false
  },
  mutations: {
    setBootstrapData: function setBootstrapData(state, bootstrapData) {
      state.bootstrapData = bootstrapData;
    },
    storePost: function storePost(state, bootstrapData) {
      var slug = bootstrapData.post.slug;
      state.posts[slug] = bootstrapData;
    },
    setPage: function setPage(state, pageData) {
      var slug = pageData.slug;
      state.pages[slug] = pageData;
    },
    setAdBlockPlusEnabled: function setAdBlockPlusEnabled(state) {
      document.querySelector('html').style.overflow = 'hidden';
      document.querySelector('body').style.overflow = 'hidden';
      state.adBlockPlusEnabled = true;
    },
    setCategory: function setCategory(state, categoryData) {
      state.categories[categoryData.slug] = categoryData.pages;
    },
    setTag: function setTag(state, tagData) {
      state.tags[tagData.slug] = tagData.pages;
    },
    setExternalData: function setExternalData(state, externalData) {
      state.externalData = externalData;
    }
  },
  getters: {
    sidebar: function sidebar(state) {
      return state.sidebar;
    },
    bootstrap: function bootstrap(state) {
      return state.bootstrap;
    },
    categories: function categories(state) {
      return state.bootstrapData.categories;
    },
    adsense: function adsense(state) {
      return state.googleAdSenseClientId;
    },
    tags: function tags(state) {
      return state.bootstrapData.tags;
    },
    apiProxyUrl: function apiProxyUrl(state) {
      return state.apiProxyUrl;
    },
    externalData: function externalData(state) {
      return state.externalData;
    },
    post: function post(state) {
      return function (id) {
        return state.posts[id];
      };
    },
    getLangKey: function getLangKey(state) {
      return function (key) {
        return state.lang[key];
      };
    },
    category: function category(state) {
      return function (slug) {
        return state.categories[slug];
      };
    },
    tag: function tag(state) {
      return function (slug) {
        return state.tags[slug];
      };
    },
    getInfoBox: function getInfoBox(state) {
      return state.bootstrapData.infoBox;
    },
    page: function page(state) {
      return function (slug) {
        return state.pages[slug];
      };
    }
  }
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  store: store,
  template: '<App/>',
  components: {
    App: src_App
  },
  created: function created() {
    this.bootstrap();
  },
  data: function data() {
    return {
      asyncConfig: '/static/data/async-config.json', // data loaded after the app bootstrap with ajax
      homePagePostsCount: config.homePagePostsCount, // number of post excerpts to show on the home page,
      infoBoxPageSlug: config.infoBoxPageSlug // slug of the page, which content will be displayed in the info box in the sidebar
    };
  },

  computed: {
    /**
     * Get the bootstrap URLS
     */
    getBootstrapUrls: function getBootstrapUrls() {
      return this.$store.getters.bootstrap;
    },

    /**
     * Get the API endpoint
     */
    getProxyUrl: function getProxyUrl() {
      return this.$store.getters.apiProxyUrl;
    }
  },
  methods: {
    /**
     * Create an API url from a slug
     * @filter makeProxyUrl
     * @param {String} slug
     * @return {String}
     */
    makeProxyUrl: function makeProxyUrl(slug) {
      return '' + this.getProxyUrl + slug;
    },

    /**
     * Bootstrap the initially required data and mount the app
     * @filter bootstrap
     * @return {void}
     */
    bootstrap: function bootstrap() {
      var _this = this;

      var url = this.getProxyUrl + '?bootstrap=true&count=' + this.homePagePostsCount + '&infoBarPageSlug=' + this.infoBoxPageSlug;
      var $http = this.$http;
      var bootstrapData = {};
      $http(url).then(function (response) {
        response = response.data;
        var infoBox = response.infoBox;
        bootstrapData = {
          recentPosts: response.recentPosts.posts,
          tags: response.tags,
          categories: response.categories,
          infoBox: infoBox
        };
        _this.$store.commit('setBootstrapData', bootstrapData);
        _this.$store.commit('setPage', infoBox);
        _this.$http(_this.asyncConfig).then(function (response) {
          _this.$store.commit('setExternalData', response.data);
          _this.$mount('#app');
        });
      });
    }
  }
});

/***/ }),

/***/ "NU3e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ue/Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WtHi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aj5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ej7G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwwO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rWWX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.87640637d2e8e8a7ad65.js